import React from "react";
import { Route, Redirect } from "react-router";

import { useGoogleAuth } from "../contexts/auth";

function ProtectedRoute({ children, ...rest }) {
  const { isSignedIn } = useGoogleAuth();

  return (
    <Route {...rest} render={() => {
      return isSignedIn
        ? children
        : <Redirect to="/" />
    }} />
  );
}

export default ProtectedRoute;
